<input type="number"
       [placeholder]="placeholder"
       [(ngModel)]="value"
       [disabled]="disabled"
       [min]="min"
       [max]="max"
       (input)="onChange($event)"
       (blur)="onTouched()">
